import React, { Component } from "react";
import { Form, Button, Message, Icon, Modal, Divider } from 'semantic-ui-react'
import { invokeApig } from "../libs/awsLib";
import { rendersubcomponents } from "../libs/renderFunctions";
import { Link } from "react-router-dom";
import LoadingPage from "./LoadingPage"


export default class FunctionModal extends Component {
  constructor(props) {
    super(props);
    this.state=this.defaultState;
    this.setAddress=this.setAddress.bind(this)
  }
  
  defaultState={formData: {}, functiondefinition: {}, fieldnames: null, fieldsValid: {}, formValid: true, isFunctionLoaded: false, submitFailed: false, submitSuccess: false, validationErrors: [], validationWarnings: [], isExecuting: false, newid: false, authorised: true};

  loadFunction=(functionname)=>{
    //get function definition    
    invokeApig({path: "/functions/" + functionname, method: "GET",  body: null, queryParams: ['id='+this.props.parententityid]}).then((result)=>{
        
        if(result.status===200){
          // set field values in state
          var newstate={functiondefinition: result.data, isFunctionLoaded: true, formData: {}, fieldnames: []};
          for (var i=0;i<result.data.components.length;i++)
          {
            var component=result.data.components[i];
            var fieldname=component.fieldname
            if(component['type']==='AddressBox')
            {
              const addressFields=['subbuildingname', 'buildingname', 'buildingnumber', 'dependentthoroughfare', 'thoroughfare', 'doubledependentlocality', 'dependentlocality', 'posttown', 'county', 'postcode']
              addressFields.forEach((fieldname)=>{
                  newstate.formData[fieldname]='';
                  newstate.formData[fieldname+'_valid']=true;
                  newstate.fieldnames.push(fieldname)
              })
              
            }
            else if (component.type==='TableInput')
            {
              newstate.formData[component.name]= [];
              newstate.formData[component.name+'_valid']=true;
              newstate.fieldnames.push(component.name);
            }      
            else if (component.type==='HiddenValue')
            {
              if ('value' in component)
              {
                newstate.formData[component.fieldname]= component.value;
                newstate.formData[component.fieldname+'_valid']=true
              }
              
              else if ('fieldname' in component)
              {
                var parsefield=component.fieldname.split('$')
                if(parsefield.length===1)
                {
                  newstate.formData[component.fieldname]= newstate[parsefield[0]];
                  newstate.formData[component.fieldname+'_valid']=true
                }
                else if(parsefield.length===2)
                {
                  newstate.formData[parsefield[1]]= this.props[parsefield[0]][parsefield[1]];
                  newstate.formData[parsefield[1]+'_valid']= true
                  fieldname=parsefield[1]
                }

              }

              newstate.fieldnames.push(fieldname);
            }      
            else if (component.type==='MPANField') 
            {
              newstate.formData[component.fieldname]= null;
              newstate.formData[component.effectivedatefield]= null;
              newstate.formData[component.fieldname+'_valid']=true
              newstate.formData[component.effectivedatefield+'_valid']=true
              newstate.fieldnames.push(component.fieldname);
              newstate.fieldnames.push(component.effectivedatefield);
            }      
            else if (component.type==='AgentField') 
            {
              newstate.formData[component.fieldname]= null;
              newstate.formData[component.effectivedatefield]= null;
              newstate.formData[component.agenttypefield]= null;
              newstate.formData[component.fieldname+'_valid']=true
              newstate.formData[component.effectivedatefield+'_valid']=true
              newstate.formData[component.agenttypefield+'_valid']=true
              newstate.fieldnames.push(component.fieldname);
              newstate.fieldnames.push(component.effectivedatefield);
              newstate.fieldnames.push(component.agenttypefield);
            }  
            else if (component.type==='MPANCombination') 
            {
              newstate.formData['profileclassid']= null;
              newstate.formData['metertimeswitchcode']= null;
              newstate.formData['linelossfactorclassid']= null;
              newstate.formData['standardsettlementconfigurationid']= null;
              newstate.formData['profileclassid_valid']= true;
              newstate.formData['metertimeswitchcode_valid']= true;
              newstate.formData['linelossfactorclassid_valid']= true;
              newstate.formData['standardsettlementconfigurationid_valid']= true;


              newstate.fieldnames.push('profileclassid');
              newstate.fieldnames.push('metertimeswitchcode');
              newstate.fieldnames.push('linelossfactorclassid');
              newstate.fieldnames.push('standardsettlementconfigurationid');

              //this.state.fieldnames.push(component.effectivedatefield);
            }                
            else if (component.type==='CheckBox')
            {
              newstate.formData[component.fieldname]= false;
              newstate.formData[component.fieldname+'_valid']=true
              newstate.fieldnames.push(component.fieldname);
            }            
            else
            {
              if ('default' in component)
              {
                newstate.formData[component.fieldname]= component.default;
                newstate.formData[component.fieldname+'_valid']=true;
              }
                
              else
              {
                newstate.formData[component.fieldname]= null;
                if ('nullable' in component.field )
                  newstate.formData[component.fieldname+'_valid']=component.field.nullable;
                else
                  newstate.formData[component.fieldname+'_valid']=true;
              }
                            
                newstate.fieldnames.push(component.fieldname);
            }      
          }
      

        newstate.components=(result.data.components.length>0)
        this.setState(newstate);

        //if no data required then execute straight away
        if (result.data.components.length===0 && !this.state.isExecuting)
        {
          this.executeFunction(null)
        }
      
        // //add parent entity
        // newstate[this.props.parententity +'id']=this.props.parententityid;
        // newstate[this.props.parententity +'id_valid']=true;
        // this.state.fieldnames.push(this.props.parententity +'id');

      }
      else if(result.status===401)
      {
        console.log('result', result)
        this.setState({authorised: false, isFunctionLoaded: true, functiondefinition: result.data})
      } 
        
        });
        

  }

  async componentDidMount() {
    // this.setState(this.defaultState);
    const functionname=this.props.functionName;
    if(functionname) this.loadFunction(functionname)
      
  }




  async componentWillReceiveProps(nextProps) {

    if (nextProps.visible !== this.props.visible)
      this.setState(this.defaultState);

    if (nextProps.functionName) 
    {
      const functionname=nextProps.functionName;
      if(functionname.length>0 && this.props.parameters!==nextProps.parameters) this.loadFunction(functionname)
     
    } 
  }

executeFunction=async event => {
  if(event) event.preventDefault();
  this.setState({isExecuting: true});
  //replace parententityid parameter
  

  var parameters=this.props.parameters;
  if (!Array.isArray(parameters))
  parameters=[parameters]

  // replace other any parameters in url with values
  this.setState({submitFailed:false, submitSuccess: false, validationErrors: []});
  
  var success=true;
  var errors=[];
  var warnings=[];

  parameters.forEach(parameter=>{
    var url=this.state.functiondefinition.url.replace('{parententityid}', this.props.parententityid);
  const regexp=/\{.*?\}/
  while (regexp.test(url))
  {
      var parametername=regexp.exec(url);
      url=url.replace(parametername[0], parameter[parametername[0].slice(1,-1)]);
  }

  //create json object with form data
  var functionData={}
  var field;
  for(var i = 0; i<this.state.fieldnames.length; i++)
  {
    field=this.state.fieldnames[i];
    functionData[field]=this.state.formData[field]
  }
  // console.log(JSON.stringify(functionData));


    invokeApig({path: url, method: "POST",  body: functionData}).then(result=>{
    console.log(result)
    if(result.status===200 || result.status===201) 
    {
        if ('warnings' in result.data)
          this.setState({isExecuting: false, submitFailed:false, submitSuccess: true, validationErrors: [], validationWarnings: result.data.warnings, newid: result.data.id});
        else
          this.setState({isExecuting: false, submitFailed:false, submitSuccess: true, validationErrors: []});
    }  
    else if(result.status===400) 
    {
      success=false;
      errors=result.data;
      this.setState({isExecuting: false, submitFailed:true, submitSuccess: false, validationErrors: errors});
    }
    else if(result.status===401) 
    {
    success=false;
    errors.push('You are not authorised to perform this action')
    this.setState({isExecuting: false, submitFailed:false, submitSuccess: true, validationErrors: errors});
    } 
    else if(result.status===404) 
    {
      success=false;
      errors.push('API endpoint not found')
      this.setState({isExecuting: false, submitFailed:false, submitSuccess: true, validationErrors: errors});
      } 
  
    else if(result.status===502) 
    {
      success=false;
      errors.push('An error occurred executing the request')
      this.setState({isExecuting: false, submitFailed:false, submitSuccess: true, validationErrors: errors});
      } 
  
    else
    {
      success=false;
      errors.push('Unrecognised error code ' + result.status)
      this.setState({isExecuting: false, submitFailed:false, submitSuccess: true, validationErrors: errors});
      } 
  }).catch(err=>
    {
      success=false;
      errors.push('An error occurred executing the request')
      this.setState({isExecuting: false, submitFailed:false, submitSuccess: true, validationErrors: errors});
    })

  })
  
}


updateAddress=(subbuildingname, buildingname, buildingnumber, dependentthoroughfare, thoroughfare, doubledependentlocality, dependentlocality, posttown, county, postcode)=>{
    var formData=this.state.formData;
    formData.subbuildingname= subbuildingname;
    formData.buildingname= buildingname;
    formData.buildingnumber= buildingnumber;
    formData.dependentthoroughfare= dependentthoroughfare;
    formData.thoroughfare= thoroughfare;
    formData.doubledependentlocality= doubledependentlocality;
    formData.dependentlocality= dependentlocality;
    formData.posttown= posttown;
    formData.county= county;
    formData.postcode= postcode;
    this.setState({formData: formData})
    //this.setState({formData.subbuildingname: subbuildingname, buildingname: buildingname, buildingnumber: buildingnumber, dependentthoroughfare: dependentthoroughfare, thoroughfare: thoroughfare, doubledependentlocality: doubledependentlocality, dependentlocality: dependentlocality, posttown: posttown, county: county , postcode: postcode})
}

closeButtonClicked=()=>{
  //this.resetState()
  this.setState(this.defaultState);
  this.props.closefunctionmodal(this.state.submitSuccess)

}

  setDataValue=(fieldname, field, value, valid=true)=>  {

    // set data
    // this.setState({[fieldname]: value, [fieldname+'_valid']: valid});

    var formData=this.state.formData;
    formData[fieldname]=value;
    formData[fieldname+'_valid']=valid

    // update valid fields
    const formValid=this.state.fieldnames.reduce((accumulator, currentvalue)=>{return accumulator && ((currentvalue===fieldname) ? valid : this.state.formData[currentvalue.concat('_valid')])}, true);
    //console.log(formValid);
    //console.log(this.state.fieldnames.reduce((accumulator, currentvalue)=>{return accumulator.concat(currentvalue)}, ''))
    this.setState({formData: formData, formValid: formValid})
  }

  setAddress(subbuildingname, buildingname, buildingnumber, dependentthoroughfare, thoroughfare, doubledependentlocality, dependentlocality, posttown, county, postcode)
  {
    // // set data
    // this.setState({subbuildingname: subbuildingname, buildingname: buildingname, buildingnumber: buildingnumber, dependentthoroughfare: dependentthoroughfare, thoroughfare: thoroughfare, doubledependentlocality: doubledependentlocality, dependentlocality: dependentlocality, posttown: posttown, county: county, postcode: postcode});
    var formData=this.state.formData;
    formData.subbuildingname= subbuildingname;
    formData.buildingname= buildingname;
    formData.buildingnumber= buildingnumber;
    formData.dependentthoroughfare= dependentthoroughfare;
    formData.thoroughfare= thoroughfare;
    formData.doubledependentlocality= doubledependentlocality;
    formData.dependentlocality= dependentlocality;
    formData.posttown= posttown;
    formData.county= county;
    formData.postcode= postcode;
    this.setState({formData: formData})    
  }


  render() {
      const modalStyle = {
      modal : {
        marginTop: '0px !important',
        marginLeft: 'auto',
        marginRight: 'auto'
      }
    };
    return (
        this.state.authorised ?
        <Modal style={modalStyle.modal} open={this.props.visible}>
        <Modal.Header size='tiny'>
          <h3 className="seaglassblue"><Icon circular className="seaglassblue" name={this.state.functiondefinition.icon}/>{this.state.functiondefinition.title}</h3>
        </Modal.Header>  
        <Modal.Content>
        {this.state.isFunctionLoaded ? 
        <Form>
        {rendersubcomponents(this.state.functiondefinition, this.state.formData, this.setDataValue, this.setAddress, this.props.parameters)}
        <Message
          success
          visible={this.state.submitSuccess}
          header={this.state.validationWarnings.length>0 ? "Action Completed With Warnings" : "Action Completed Successfully"}
          list={this.state.validationWarnings}
          content={(this.props.functionName==='addcustomer' && this.state.newid) ? <Link to={'/view/customer/'+this.state.newid}>{'Customer Id: ' + this.state.newid}</Link>: ""}
        />
        <Message
          error
          visible={this.state.submitFailed}
          header="Action Failed"
          list={this.state.validationErrors}
        />
        <Divider/>
        {this.state.components && <Button className="seaglassbutton" disabled={!this.state.formValid || this.state.submitSuccess} loading={this.state.isExecuting} onClick={this.executeFunction}>Save</Button>}
        <Button className="seaglassbutton" onClick={this.closeButtonClicked}>Close</Button>
        </Form>
        :
        <LoadingPage/>}
        </Modal.Content>
        </Modal>
        :
        <Modal open={this.props.visible}>
        <Modal.Header size='tiny'>
          <h3 className="seaglassblue"><Icon circular className="seaglassblue" name={this.state.functiondefinition.icon}/>{this.state.functiondefinition.title}</h3>
        </Modal.Header>  
        <Modal.Content>
        {this.state.isFunctionLoaded ? 
        <Form>
        <Message
          warning
          visible
          header="You are not authorised to use this function, please speak to your system administrator for access."
        />
        <Divider/>
        <Button className="seaglassbutton" onClick={this.closeButtonClicked}>Close</Button>
        </Form>
        :
        <LoadingPage/>}
        </Modal.Content>
        </Modal>   
      
    );
  }
}